import TutorialsSection from './tutorialsSection'

export default TutorialsSection



// WEBPACK FOOTER //
// ./client/pages/home/tutorialsSection/index.tsx